import React, { Component } from 'react';
import injectTapEventPlugin from 'react-tap-event-plugin';
import _  from 'lodash';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import darkBaseTheme from 'material-ui/styles/baseThemes/darkBaseTheme';
import lightBaseTheme from 'material-ui/styles/baseThemes/lightBaseTheme';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import Snackbar from 'material-ui/Snackbar';
import Controls from './Controls';
import AvailableButtons from './AvailableButtons';
import details from './details';

import './App.css';

injectTapEventPlugin();

class App extends Component {
  constructor(props) {
    super(props);

    this.state = {
      availableSites: [],
      selectedSite: false,
      webFontEmbeds: '',
      externalStylesheets: '',
      availableClasses: [],
      ctaString: '',
      activeIndex: undefined,
      formIsReady: false,
      isGenerated: false,
      themeIsDark: false,
      isLoadingSite: false,
    };
  }

  componentDidMount = () => {
    fetch(`${details.apiUrl}/sites`).then(res => {
      return res.json();
    }).then(data => {
      this.setState({
        availableSites: _.sortBy(data, 'name'),
      });
    });
  }

  handleSiteChange = (event, value) => {
    this.setState({
      selectedSite: this.state.availableSites[value].name,
      webFontEmbeds: this.state.availableSites[value].web_font_embeds,
      availableClasses: this.state.availableSites[value].available_classes.split('\n'),
      externalStylesheets: this.state.availableSites[value].stylesheets.split('\n'),
      activeIndex: value,
    });

    if (this.state.isGenerated) {
      this.setState({
        isLoadingSite: true,
      });

      setTimeout(() => {
        this.setState({
          isLoadingSite: false,
        });
      }, 2000);
    }

    if (this.state.availableSites[value].web_font_embeds !== '') {
      // test for typekit
      const findTypekitSrc = /\<script src="(.+)\"/gi.exec(this.state.availableSites[value].web_font_embeds);
      if (findTypekitSrc !== null) {
        if (findTypekitSrc.length > 0) {
          // type kit url found
          const script = document.createElement('script');
          script.src = findTypekitSrc[1];
          script.async = true;

          // inject script
          document.body.appendChild(script);
          setTimeout(() => {
            window.eval('try{Typekit.load({ async: true });}catch(e){}');
          }, 100);
        }
      }
    }
  }

  handleCtaString = (event, value) => {
    this.setState({
      ctaString: value,
    });

    if (value !== '' && this.state.selectedSite !== false) {
      this.setState({
        formIsReady: true,
      });
    } else {
      this.setState({
        formIsReady: false,
      });
    }
  }

  triggerGenerated = (event) => {
    this.setState({
      isGenerated: true,
      isLoadingSite: true,
    });

    setTimeout(() => {
      this.setState({
        isLoadingSite: false,
      });
    }, 2000);
  }

  toggleTheme = () => {
    this.setState({
      themeIsDark: !this.state.themeIsDark,
    });
  }

  render() {
    let availableButtons;

    if (this.state.isGenerated) {
      availableButtons = <AvailableButtons
        availableClasses={this.state.availableClasses}
        ctaString={this.state.ctaString}
        webFontEmbeds={this.state.webFontEmbeds}
        externalStylesheets={this.state.externalStylesheets}
        context={this.state.availableSites[this.state.activeIndex]}
      />;
    }

    return (
      <div className={this.state.themeIsDark ? 'App App--dark' : 'App App--light'}>
        <MuiThemeProvider muiTheme={this.state.themeIsDark ? getMuiTheme(darkBaseTheme) : getMuiTheme(lightBaseTheme)}>
          <div>
            <Controls 
              title="MediaJunction CTA Generator"
              availableSites={this.state.availableSites} 
              handleSiteChange={this.handleSiteChange} 
              handleCtaString={this.handleCtaString} 
              formIsReady={this.state.formIsReady}
              toggleTheme={this.toggleTheme}
              themeIsDark={this.state.themeIsDark}
              triggerGenerated={this.triggerGenerated}
              activeIndex={this.state.activeIndex}
            />
            {availableButtons}
            <Snackbar
              open={this.state.isLoadingSite}
              message="Loading…"
              autoHideDuration={2000}
            />
          </div>
        </MuiThemeProvider>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js